import { ApplicantDecisionAction } from '../ApplicantDecisionAction'

import * as styles from './ApplicantDecisionActions.module.css'

function ApplicantDecisionActions({
  actions,
  className = styles.ApplicantDecisionActions,
  onClick,
}) {
  return actions.length > 0 ? (
    <div className={className}>
      {actions.map(action => (
        <ApplicantDecisionAction
          action={action}
          key={action.key}
          onClick={onClick}
        />
      ))}
    </div>
  ) : null
}

export default ApplicantDecisionActions
